/**
 * ブランド人気スコアのデバッグ出力。
 * 有効化: 下記を true に変更する。
 */
export const BRAND_POPULARITY_DEBUG = false;

const collator = new Intl.Collator('ja');

/**
 * sortBrandItems
 * @param {HTMLElement} list
 * @param {string} itemSelector
 * @param {string} sortBy
 */
export function sortBrandItems(list, itemSelector, sortBy) {
    const items = Array.from(list.querySelectorAll(itemSelector));

    items.sort((a, b) => {
        switch (sortBy) {
            case 'popularity': {
                const scoreDiff = Number(b.dataset.sortPopularity) - Number(a.dataset.sortPopularity);
                if (scoreDiff !== 0) return scoreDiff;
                return Number(a.dataset.sortOrder) - Number(b.dataset.sortOrder);
            }
            case 'name':
                return collator.compare(
                    a.dataset.sortName || '',
                    b.dataset.sortName || ''
                );
            case 'date':
                return Number(b.dataset.sortDate) - Number(a.dataset.sortDate);
            default:
                return 0;
        }
    });

    items.forEach(item => list.appendChild(item));
    return items;
}

/**
 * logBrandPopularityScores
 * @param {HTMLElement} list
 * @param {string} itemSelector
 * @param {string} label
 */
export function logBrandPopularityScores(list, itemSelector, label = 'ブランドスコア合算') {
    if (!BRAND_POPULARITY_DEBUG) return;

    const brands = Array.from(list.querySelectorAll(itemSelector))
        .map((item, index) => ({
            rank: index + 1,
            name: item.dataset.sortName,
            totalScore: Number(item.dataset.sortPopularity),
            order: Number(item.dataset.sortOrder)
        }));

    console.group(`[Brand Popularity Debug] ${label}（ソート結果）`);
    brands.forEach((brand, index) => {
        console.log(
            `${index + 1}位 合算スコア: ${brand.totalScore}`,
            brand.name
        );
    });
    console.table(brands.map((brand, index) => ({
        rank: index + 1,
        name: brand.name,
        totalScore: brand.totalScore,
        order: brand.order
    })));
    console.groupEnd();
}
